import styled from 'styled-components';

export const ShowcaseLabelDefaultBox = styled.label`
    cursor: pointer;
    ${({theme}) => theme.font.presets.bold};
    font-size: 2rem;
`;